/**
 * @desc Keys of the service endpoints (urls) stored in the Redux store.
 * @example
 * import * as SERVICE_ENDPOINTS from 'constants/endpoints';
 * console.log( SERVICE_ENDPOINTS.FETCH_CART_ITEMS );
 */

// site header and site footer
export const SITE_HEADER = 'fetchSiteHeaderInfo';
export const SITE_FOOTER = 'fetchSiteFooterInfo';
